import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie';
import VuexPersistence from 'vuex-persist';
import modules from './modules';

const vuexCookie = new VuexPersistence({
  key: 'vma',
  storage: window.sessionStorage,
  restoreState: (key) => {
    if (!Cookies.getJSON(key)) {
      Cookies.set(key, '{"auth": { "JSESSIONID":"", "user":{} }}')
    }
    return Cookies.getJSON(key)
  },
  saveState: (key, state) => Cookies.set(key, state),
  modules: ['auth']
});

const vuexLocal = new VuexPersistence({
  key: 'vma',
  storage: window.localStorage,
  modules: ['map', 'cameras']
});

const sosCallV2Persist = new VuexPersistence({
  key: 'kalan:sos-call-v2',
  storage: window.localStorage,
  modules: ['sos-call-v2'],
  reducer: (state) => ({
    'sos-call-v2': {
      lastActiveCallId: state['sos-call-v2'].lastActiveCallId,
      overlayOpen: state['sos-call-v2'].overlayOpen,
      mode: state['sos-call-v2'].mode,
      floatingPos: state['sos-call-v2'].floatingPos,
      floatingSize: state['sos-call-v2'].floatingSize,
    },
  }),
});

Vue.use(Vuex);
const store = new Vuex.Store({
  modules,
  plugins: [vuexCookie.plugin, vuexLocal.plugin, sosCallV2Persist.plugin]
});

export default store;
